import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { getCountryListOptions } from '../../../constants/countryList';
import { Dropdown } from '@hid-galaxy-ui/galaxy-react';

const useInputStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: theme.custom.inputs.maxWidth,
    marginBottom: theme.spacing(5),
  },
}));

const InputSelectCountry = (props) => {
  const classes = useInputStyles();
  const { field, form, value, required=false, label, hint, className, propsHasError = false } = props;
  const { name: fieldName, value: fieldValue } = field || {};
  
  const { errors, setFieldValue } = form || {};

  const getSelectedValue = () => {
    if (fieldValue) {
      const obj = getCountryListOptions().find((option) => option.key === fieldValue);
      return obj ? { label: obj.label, value: obj.key } : null;
    }
    return null;
  };

  const [selected, setSelected] = useState(fieldValue ? fieldValue : null);
  const [options, setOptions] = useState();

  // const dispatch = useDispatch();

  // const handleMenuItemClick = (_event, option) => {
  //   // dispatch(allActions.formConfigActions.setSelectedCountry(option?.key));
  // };

  useEffect(() => {
    setOptions(optionElements());
  }, []);

  useEffect(() => {
    setSelected(getSelectedValue());
  }, [fieldValue]);

  const optionElements = () =>
    getCountryListOptions().map((option) => {
      return {
        label: option.label,
        value: option.key,
      };
    });

  const handleOnSelect = (selectedValueObj) => {
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, selectedValueObj?.value);
    } else if (onChange) {
      onChange(selectedValueObj);
    }
    setSelected(selectedValueObj);
  };
  return (
    <div className={className}>
      <Dropdown
        id={fieldName}
        selected={selected}
        label={label}
        options={options}
        isClearable={true}
        isSearchable={true}
        onSelect={(value) => handleOnSelect(value)}
        placeholder={hint}
        isRequired={required}
      />
    </div>
  );
};

InputSelectCountry.propTypes = {
  // required: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  // hint: PropTypes.string,
  // options: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  //     value: PropTypes.string,
  //   }),
  // ).isRequired,
};

InputSelectCountry.defaultProps = {
  hint: null,
};

export default InputSelectCountry;
